<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">new custom bonds</small>
      </legend>
      <div></div>
      <div>
        <div class="custombondsLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>laoding...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemCustombonds"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'add bond!'"
                class="btn btn-info btn-sm btn-rounded"
                @click="viewCustomBond(props.row.id)"
              >
                <i class="fa fa-plus"></i> Add bond
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter file reference"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter bill of landing"
          }
        },
        {
          label: "Cargo no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "cargo number"
          }
        },
        {
          label: "Cargo size",
          field: "cargo_size",
          type: "text"
        },
        {
          label: "T810 entry",
          field: "t810_entry",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },

  created() {
    this.loadCustombonds();
  },
  computed: {
    ...mapGetters(["systemCustombonds"])
  },
  methods: {
    ...mapActions(["loadCustombonds", "viewCustomBond"])
  }
};
</script>


// WEBPACK FOOTER //
// src/bonds/managecustombonds.vue